import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project import
import Loadable from "../components/@ui/loader/Loadable";
import MainLayout from "../components/@layouts/MainLayout";
import LandingPage from "../pages/landing-page";

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [{ path: "", element: <LandingPage /> }],
};

MainRoutes.children.push({
  path: "*",
  element: <Navigate to="/404" replace />,
});

export default MainRoutes;
